<template>
    <tr :class="{'table-row-label' : item.label && item.level > 0, 'highlight' : item.highlight}">
        <template v-if="item.label">
            <td :id="getId()" :class="[getLabelClass(), {'scroller-noborder-column': item.level == 1}]" class="font-bold scroller-fixed-column">
                {{ item.label }}
            </td>
            <td :colspan="columns.length - 1" :class="getLabelClass()">
                &nbsp;
            </td>
        </template>
        <template v-else-if="item.blankRow">
            <td :colspan="columns.length">
                &nbsp;
            </td>
        </template>
        <template v-else>
            <td v-for="(column, index) in columns" :class="{'scroller-fixed-column': index == 0}" :data-type="column.label">
                <div v-if="isButtonField(column)">
                    <!-- Hide button is only used on option quotes -->
                    <button-group
                        v-if="!item.hideButton"
                        :symbol="getSymbol(column)"
                        :classes="column.classes"
                        :groups="column.buttons">
                    </button-group>
                </div>

                <div v-else-if="isSlot(column)">
                    <component
                        v-bind="column.slotFields"
                        :formatted="item"
                        :label="column.label"
                        :raw="item.raw"
                        :is="componentsMap[column.slotName]" />
                </div>

                <data-table-cell
                    v-else
                    :type="getMeta(column.field)"
                    :raw="getRaw(column.field)"
                    :value="item[column.field]">
                </data-table-cell>
            </td>
        </template>
    </tr>
</template>

<script setup>
import { ref } from 'vue';

import DataTableCell from './DataTableCell';
import TrendRankingCell from './slots/TrendRankingCell';
import TrendSeekerTrend from './slots/TrendSeekerTrend';
import PivotFormation from './slots/PivotFormation';
import HighsLowsCell from './slots/HighsLowsCell';
import CommodityLinkCell from './slots/CommodityLinkCell';
import ContractWithExpirationCell from './slots/ContractWithExpirationCell';
import ContractLinkWithDateCell from './slots/ContractLinkWithDateCell';
import TrendSpotterPositionCell from './slots/TrendSpotterPositionCell';
import TrendSpotterStochasticKCell from './slots/TrendSpotterStochasticKCell';
import BarchartContractLinkCell from './slots/BarchartContractLinkCell';

// Used on the expiration-dates page
import ContractExpirationLinkCell from './slots/ContractExpirationLinkCell';
import ExchangeSymbolCell from './slots/ExchangeSymbolCell';
import SignalCTTP from './slots/SignalCTTP';

// Props
const props = defineProps({
    item: Object,
    meta: Object,
    columns: Array
});

const componentsMap = {
    TrendRankingCell,
    TrendSeekerTrend,
    PivotFormation,
    HighsLowsCell,
    CommodityLinkCell,
    ContractWithExpirationCell,
    ContractLinkWithDateCell,
    TrendSpotterPositionCell,
    TrendSpotterStochasticKCell,
    BarchartContractLinkCell,

    ContractExpirationLinkCell,
    ExchangeSymbolCell,
    SignalCTTP,
};

// Computed and Methods
const rowHasGroup = (row) => {
    return row.group && row.group.rows && row.group.rows.length > 0;
};

const isSlot = (column) => {
    return column.slotName;
};

const isButtonField = (column) => {
    return column.field === 'buttons' && column.buttons.length > 0;
};

const getId = () => {
    return props.item.label
        .replace('/', '-')
        .toLowerCase();
};

const getMeta = (field) => {
    if (props.meta && props.meta.field && props.meta.field.type) {
        return props.meta.field.type[field];
    } else {
        // if (process.env.NODE_ENV === 'development') {
        //     console.warn(`No meta found for field: ${field}`);
        // }
    }
};

const getRaw = (field) => {
    if (props.item && props.item.raw) {
        return props.item.raw[field];
    } else {
        // if (process.env.NODE_ENV === 'development') {
        //     console.warn(`No raw found for field: ${field}`);
        // }
    }
};

const getSymbol = (column) => {
    // If this column is not keyed by symbol
    if (column.symbolKey) {
        return props.item[column.symbolKey];
    }

    return props.item.symbol;
};

const getLabelClass = () => {
    if (props.item.level === 0) {
        return `uppercase font-semibold bg-yellow-200`;
    }
};
</script>
